import { Context, createContext } from 'react';
import { Socket } from 'socket.io-client';

export const SocketContext: Context<Socket | undefined> = createContext<Socket | undefined>(undefined);
